/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-08 22:14:36
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-12-01 13:39:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/tools/index.ts
 */
import { checkAdvancedPrice } from './advancedPrice';
import { EnumProductType, EnumStatus } from 'src/types/common/product';
import { EnumUnitStandard } from 'src/types/common/common';
import { UnitType } from '@/src/types/common/common';
import {
  IAdvancedPriceSetting,
  IProductSet,
  IAdvancedPriceSettingItem,
} from '../type';
import { validate } from './validation';
import { settleData } from './submitData';
// import { store } from 'src/store';
// import { getSetAndDefaultPrice } from '../slice';
import { instanceType, AllTypes } from 'src/tools/helper';
import { convertDatafromServer } from './convertDatafromServer';
import { accAdd, accMul } from 'src/tools/math';
export { validate, checkAdvancedPrice, settleData, convertDatafromServer };

export const defaultData = {
  linkedSalesChannels: [],
  storeUuid: '1',
  status: EnumStatus.Draft,
  measurementUnits: [],
  brands: [],
  countries: [],
  currencies: [],
  priceTiers: [],
  productInfo: {
    sku: '',
    name: '',
    measurementUnit: {},
    remarks: '',
    codes: [],
    description: '',
    brand: {},
    barcode: '',
  },
  tags: {
    tags: [],
  },
  productSetItemsEmptyError: false,
  productSetItems: <IProductSet[]>[],
  // stock: {
  //   quotaEnabled: false,
  //   inventoryQuota: null,
  //   stockQuantity: 0,
  //   stockAvailable: 0,
  // },
  priceSettings: {
    defaultSalePrice: 0,
    taxRule: null,
    cost: 0,
  },
  advancedPriceSettings: <IAdvancedPriceSetting<IAdvancedPriceSettingItem>[]>[
    // {
    //   items: [
    //     {
    //       unitPrice: 3,
    //       productUuid: 1,
    //       productName: 'asdasd',
    //       noOfUnit: 5,
    //     },
    //   ],
    //   setPrice: 3,
    // },
  ],
  advancedPriceSettingsOpen: true,
  dimensions: {
    weight: null,
    weightUnit: UnitType.Kilogram,
    measurementUnit: UnitType.Metre,
    length: null,
    width: null,
    volume: null,
    height: null,
  },
  customsInformation: {},
  customsInformationItems: [],
  productStorage: {},

  productType: EnumProductType.Set,
  thumbnailImage: null,

  defaultCurrency: null,
  fileList: [],
  inventoryUuid: null,
  uuid: null,
  subCollapseOpen: {
    // salesChannelAvailableQuantity: true,
    // salesChannelAvailablePresaleQuantity: true,
  },
  salesChannelAvailableQuantity: [],
  // salesChannelAvailablePresaleQuantity: [],
  dimensionUnits: [
    { group: EnumUnitStandard.Imperial, values: [] },
    { group: EnumUnitStandard.Metric, values: [] },
  ],
  wightUnits: [
    { group: EnumUnitStandard.Imperial, values: [] },
    { group: EnumUnitStandard.Metric, values: [] },
  ],
};
const priceCompare = (productSetItems, defaultSalePrice) => {
  if (
    instanceType(defaultSalePrice) !== AllTypes.Number ||
    (productSetItems || []).length === 0
  ) {
    return true;
  }
  const totalPrice = productSetItems.reduce((pre, now) => {
    const { noOfUnit = 0, unitPrice = 0 } = now;
    return accAdd(pre, accMul(noOfUnit, unitPrice));
  }, 0);

  return totalPrice === defaultSalePrice;
};
export { priceCompare };
